import { Link } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";
import About from "../HomeMain/About";
import Appointment from "../HomeMain/Appointment";
import Testimonial from "../HomeMain/Testimonial";
import Service from "../HomeMain/Service";
import Faq from "../HomeMain/Faq";

// Cloudinary video delivery transform: q_auto + width cap drops the hero video
// from ~2.76 MB to ~234 KB (background video, 1280px is plenty).
const BGVideo = "https://res.cloudinary.com/dxa2jevmo/video/upload/q_auto,w_1280,c_limit/v1761862161/Untitled_design_zzjh1h.mp4";

const Main = () => {
  const { t } = useTranslation();

  return (
    <>
      <main>
        <section id="home" className="slider-area fix p-relative">
          <div style={{ background: "#0d0703", position: "relative", overflow: "hidden" }}>

            {/* Video background */}
            <video
              autoPlay
              loop
              muted
              playsInline
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "center top",
                zIndex: 0,
                filter: "brightness(0.62) saturate(1.1)",
              }}
            >
              <source src={BGVideo} type="video/mp4" />
            </video>

            {/* Gradient overlay */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(to bottom, rgba(13,7,3,0.15) 0%, rgba(13,7,3,0.55) 100%)",
                zIndex: 1,
                pointerEvents: "none",
              }}
            />

            {/* Content layer */}
            <div
              className="single-slider slider-bg d-flex align-items-center"
              style={{
                position: "relative",
                zIndex: 2,
                minHeight: "100vh",
              }}
            >
              <div className="container">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-7 col-md-9 col-12" style={{ textAlign: "center" }}>
                    <div className="slider-content s-slider-content mt-20">
                      <div>
                        <p
                          data-animation="fadeInUp"
                          data-delay=".2s"
                          style={{
                            fontFamily: "'Inter', sans-serif",
                            fontSize: "11px",
                            fontWeight: "700",
                            letterSpacing: "0.28em",
                            textTransform: "uppercase",
                            color: "#D4A96A",
                            marginBottom: "20px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "12px",
                          }}
                        >
                          <span style={{ display: "inline-block", width: "28px", height: "1px", background: "#D4A96A" }} />
                          {t('home.eyebrow')}
                          <span style={{ display: "inline-block", width: "28px", height: "1px", background: "#D4A96A" }} />
                        </p>
                        <h1
                          data-animation="fadeInUp"
                          data-delay=".4s"
                          style={{
                            fontFamily: "'Cormorant Garamond', 'PT Serif', serif",
                            fontSize: "clamp(2.6rem, 7vw, 5.5rem)",
                            fontWeight: "600",
                            lineHeight: "1.1",
                            letterSpacing: "-0.02em",
                            color: "#FFFFFF",
                            marginBottom: "24px",
                          }}
                        >
                          Vision Beauty
                          <br />
                          <span style={{ color: "#D4A96A", fontStyle: "italic" }}>{t('home.tagline')}</span>
                        </h1>
                        <div
                          className="slider-btn"
                          style={{ marginTop: "40px", display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}
                        >
                          <Link
                            to="/contact"
                            style={{
                              fontFamily: "'Inter', sans-serif",
                              fontSize: "12px",
                              fontWeight: "700",
                              letterSpacing: "0.14em",
                              textTransform: "uppercase",
                              background: "#90510F",
                              color: "#fff",
                              padding: "18px 40px",
                              borderRadius: "9999px",
                              textDecoration: "none",
                              display: "inline-block",
                              boxShadow: "0 8px 28px rgba(144,81,15,0.45)",
                              transition: "background 0.3s ease, transform 0.2s ease",
                            }}
                          >
                            {t('home.bookAppointment')}
                          </Link>
                          <Link
                            to="/service"
                            style={{
                              fontFamily: "'Inter', sans-serif",
                              fontSize: "12px",
                              fontWeight: "700",
                              letterSpacing: "0.14em",
                              textTransform: "uppercase",
                              background: "rgba(255,255,255,0.12)",
                              color: "#fff",
                              padding: "18px 40px",
                              borderRadius: "9999px",
                              textDecoration: "none",
                              display: "inline-block",
                              border: "1.5px solid rgba(255,255,255,0.35)",
                              backdropFilter: "blur(8px)",
                              transition: "background 0.3s ease, border-color 0.3s ease",
                            }}
                          >
                            {t('home.ourServices')}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <About />
        <Service />
        <Appointment />
        <Faq />
        <Testimonial />
      </main>
    </>
  );
};

export default Main;
